import React from 'react';
import { Label, TextInput } from '@uhg-harmony/uitk-react';
import styled from 'styled-components';

const SpacingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem 0;
`;

const SpacingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const StyledLabel = styled(Label)`
  color: #1d1929;
  font-size: 14px;
  font-family: OptumSans;
  font-weight: 500;
  min-width: 140px;
`;

const StyledInput = styled(TextInput)`
  width: 80px;

  & input {
    font-family: OptumSans, sans-serif;
    font-size: 14px;
  }
`;

const UnitLabel = styled.span`
  color: #1d1929;
  font-size: 12px;
  font-family: OptumSans;
`;

export interface ContainerSpacingProps {
  spacingData: (data: any) => void;
  widgetState: Widget<any>;
  'data-test-id'?: string;
}

export const ContainerSpacing: React.FC<ContainerSpacingProps> = ({
  spacingData,
  widgetState,
  'data-test-id': dataTestId,
}) => {
  const [horizontalSpacing, setHorizontalSpacing] = React.useState<number>(
    widgetState.config.containerHorizontalSpacing ?? 33
  );
  const [verticalSpacing, setVerticalSpacing] = React.useState<number>(
    widgetState.config.containerVerticalSpacing ?? 23
  );

  const handleHorizontalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '') {
      setHorizontalSpacing(0);
      spacingData({
        containerHorizontalSpacing: 0,
        containerVerticalSpacing: verticalSpacing,
      });
      return;
    }

    const numValue = parseInt(value, 10);
    if (!isNaN(numValue) && numValue >= 0) {
      setHorizontalSpacing(numValue);
      spacingData({
        containerHorizontalSpacing: numValue,
        containerVerticalSpacing: verticalSpacing,
      });
    }
  };

  const handleVerticalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '') {
      setVerticalSpacing(0);
      spacingData({
        containerHorizontalSpacing: horizontalSpacing,
        containerVerticalSpacing: 0,
      });
      return;
    }

    const numValue = parseInt(value, 10);
    if (!isNaN(numValue) && numValue >= 0) {
      setVerticalSpacing(numValue);
      spacingData({
        containerHorizontalSpacing: horizontalSpacing,
        containerVerticalSpacing: numValue,
      });
    }
  };

  return (
    <SpacingContainer data-test-id={dataTestId}>
      <SpacingRow>
        <StyledLabel htmlFor="horizontal-spacing">
          Horizontal Spacing
        </StyledLabel>
        <StyledInput
          id="horizontal-spacing"
          type="number"
          value={horizontalSpacing}
          onChange={handleHorizontalChange}
          min="0"
          data-test-id="horizontal-spacing-input"
        />
        <UnitLabel>px</UnitLabel>
      </SpacingRow>
      <SpacingRow>
        <StyledLabel htmlFor="vertical-spacing">Vertical Spacing</StyledLabel>
        <StyledInput
          id="vertical-spacing"
          type="number"
          value={verticalSpacing}
          onChange={handleVerticalChange}
          min="0"
          data-test-id="vertical-spacing-input"
        />
        <UnitLabel>px</UnitLabel>
      </SpacingRow>
    </SpacingContainer>
  );
};
